// sectionAnimations.js
// Adds 'loaded' to body after page load and toggles 'in-view' on sections as they enter/exit viewport

export function initSectionAnimations() {
  // Add 'loaded' class to body after full page load
  window.addEventListener('load', () => {
    document.body.classList.add('loaded');
  });

  // Intersection Observer for sections
  const observer = new window.IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        } else {
          entry.target.classList.remove('in-view');
        }
      });
    },
    {
      threshold: 0.15 // Trigger when 15% of section is visible
    }
  );

  // Observe all sections
  document.querySelectorAll('section').forEach(section => {
    observer.observe(section);
  });
}

// Fade in .hero image after it is fully loaded
export function handleHeroImageFadeIn() {
  const heroImg = document.querySelector('.hero img');
  if (!heroImg) return;
  if (heroImg.complete) {
    heroImg.classList.add('hero-img-loaded');
  } else {
    heroImg.addEventListener('load', () => {
      heroImg.classList.add('hero-img-loaded');
    });
  }
}
